import Vuex from 'vuex';
import { getModule, getModuleName, loadModules } from 'framework/base/registry';
import overlay from '@dreipol/vue-ui/src/vuex/modules/overlay';
import scroll from '@dreipol/vue-ui/src/vuex/modules/scroll';


const config = {
    loadContext: () => require.context('framework/vuex/modules', true, /index\.js$/),
    register: (acc, { path, context }) => {
        const key = getModuleName(path, /\/([^/]+)\/([a-zA-Z0-9-]+)\.(?:js|vue$)/);
        acc[key] = getModule(path, context);

        return acc;
    },
};

/**
 * Load all store modules
 * @return {any} The store config
 */
function loadStore() {
    return {
        ...loadModules(config),
        'vue-ui': {
            namespaced: true,
            modules: { overlay, scroll },
        },
    };
}

/**
 * Create the store instance
 * @param {object} options - Pass in any additional middleware.
 * @return {Vuex.Store} The newly created vuex store
 */
function createStore({ plugins, strict } = {}) {
    const store = new Vuex.Store({
        modules: loadStore(),
        plugins,
        strict,
    });

    // NOTE: Hot reload handling
    if (module.hot && window.location.port === '3000') {
        const context = config.loadContext();

        module.hot.accept(context.id, function() {
            store.hotUpdate({
                modules: loadStore(),
            });
        });
    }

    return store;
}

/**
 * Initialize vuex
 * @return {Vuex.Store} The newly created vuex store
 */
function init() {
    const strict = process.env.NODE_ENV !== 'production';
    return createStore({ strict });
}

export default init;
